<div class="answer">
  <div class="label">Ответ:</div>
  <div class="text">{{answeredText.text}}</div>
</div>
<div class="answer correct" *ngIf="testType !== 'POLL'">
  <div class="label">Правильный ответ:</div>
  <div class="text">{{answerText.text}}</div>
</div>
